import api from './index'
import { AuthUserResource } from '../../../types'

interface SsoTokenResponseData {
  token: string
  token_type: string
  user: AuthUserResource
}

export async function postSsoToken(
  ssoJwtToken: string,
): Promise<SsoTokenResponseData> {
  const resp = await api.post<{ data: SsoTokenResponseData }>(
    '/auth/sso/token',
    {
      sso_jwt_token: ssoJwtToken,
    },
  )
  return resp.data.data
}

export async function getMe(
  accessToken: string,
  tokenType = 'Bearer',
): Promise<AuthUserResource> {
  const resp = await api.get<{ data: AuthUserResource }>('/auth/me', {
    headers: {
      Authorization: `${tokenType} ${accessToken}`,
    },
  })
  return resp.data.data
}

export async function destroyToken(
  accessToken: string,
  tokenType = 'Bearer',
): Promise<void> {
  await api.delete('/auth/token', {
    headers: {
      Authorization: `${tokenType} ${accessToken}`,
    },
  })
}
